// extracted by mini-css-extract-plugin
export default {"header":"_9G4If","logo":"_6bdLt","mark":"_6JrWQ"};